import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import styles from "./InFocusContent.module.scss";
import CustomSkeleton from "../../components/custom-skeleton/CustomSkeleton";

const InFocusCustomSkeleton: React.FC = () => {
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  return (
    <Box className={styles.skeletonGroup}>
      {isSmallScreen ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: 2,
            padding: 2,
          }}
        >
          {Array.from({ length: 2 }).map((_, idx) => (
            <Box key={idx} className={styles.card}>
              <CustomSkeleton variant="circular" width={80} height={80} />
              <CustomSkeleton
                variant="rectangular"
                width="80%"
                height={"25%"}
                sx={{ borderRadius: "16px" }}
              />
              <CustomSkeleton
                variant="rectangular"
                width="60%"
                height={"20%"}
                className={styles.buttonSkeleton}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <Box className={styles.desktopSkeletonWrapper}>
          {/* Left Circular Skeleton */}
          <CustomSkeleton
            variant="circular"
            width="16rem"
            height="16rem"
          />

          {/* Right content skeletons */}
          <Box className={styles.contentSkeletonGroup}>
            <CustomSkeleton
              variant="rectangular"
              width="80%"
              height={40}
              sx={{ borderRadius: "16px" }}
            />
            <CustomSkeleton
              variant="rectangular"
              width="80%"
              height={80}
              sx={{ borderRadius: "16px" }}
            />
            <CustomSkeleton
              variant="rectangular"
              width="20%"
              height={40}
              className={styles.buttonSkeleton}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default InFocusCustomSkeleton;


